// extracted by mini-css-extract-plugin
export var avatarBone = "_6-4";
export var buttonBone = "_6-3";
export var continueBone = "_6-a";
export var frame = "_6-1";
export var logoBone = "_6-2";
export var pickerGrid = "_6-d";
export var pitchBone = "_6-9";
export var productBone = "_6-8";
export var sectionBone = "_6-7";
export var shell = "_6-0";
export var skeletonPulse = "_6-b";
export var subtitleBone = "_6-6";
export var titleBone = "_6-5";
export var viewport = "_6-c";